

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Clientunit from '../modules/global/Settings/ClientMasterAndUnitMaster/units/UnitClients';
import States from '../modules/global/Settings/states/States';
import Permissions from '../modules/global/Settings/permissions/Permissions';
import AssignClient from '../modules/global/Settings/permissions/AssignClient';
import AssignPermission from '../modules/global/Settings/permissions/AssignPermission';
import CreateRole from '../modules/global/Settings/permissions/CreateRole';
import CreateUsers from '../modules/global/Settings/permissions/CreateUsers';
import CreatePermissions from '../modules/global/Settings/DeveloperSettings/Permissions/CreatePermissions';
import CreateForm from '../modules/global/Settings/DeveloperSettings/FormSetting/Forms/CreateForm';
import CreateAct from '../modules/global/Settings/DeveloperSettings/FormSetting/Act/CreateAct';
import CreateFrequency from '../modules/global/Settings/DeveloperSettings/FormSetting/Frequency/CreateFrequency';
import ClientForm from '../modules/global/Settings/ClientMasterAndUnitMaster/clientform';
import Holidays from '../modules/global/Settings/Holidays/Holidays';
import ClientUnitWiseHolidays from "../modules/global/Settings/ClientUnitWiseHolidays/ClientUnitWiseHolidays";
import AccessConfiguration from '../modules/global/Settings/DeveloperSettings/AccessConfiguration/AccessConfiguration';
import CreateReport from '../modules/global/Settings/DeveloperSettings/CreateReport/CreateReport';
import Dashboard from '../modules/global/dashboard/dashboard';
import NotFound from '../modules/global/notFound/NotFoundPage';
import CompanyDetails from '../modules/global/CompanyDetails/CompanyDetails'
import AllCompanyDetails from '../modules/global/CompanyDetails/AllCompanyDetails'
import UpdateCompanyDetails from '../modules/global/CompanyDetails/UpdateCompanyDetails'
import ChangePassword from '../modules/global/auth/ChangePassword/ChangePassword';
import FormConfiguration from '../modules/global/Settings/FormConfiguration/FormConfiguration';
import EmployeeBranchTransfer from '../modules/global/Settings/EmployeeBranchTransfer/EmployeeBranchTransfer';
export function Global_routes({ showSnackbar, setLoading, permissionMap = {} }) {
    return (
      <>
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/reset_password" element={<ChangePassword  showSnackbar={showSnackbar} setLoading={setLoading} />}/>

        {/* {permissionMap?.["Configuration"]?.["Developer Setting"]?.includes("States") && ( */}
          <Route path="/configuration/developer-settings/configuration/states" element={<States showSnackbar={showSnackbar} setLoading={setLoading} />} />
        {/* )} */}

        {permissionMap["Configuration"]?.["Org Details"] && (
            <>
              <Route path="/configuration/org-details" element={<ClientForm showSnackbar={showSnackbar} setLoading={setLoading} />} />
              <Route path="/configuration/unit-master/:id" element={<Clientunit showSnackbar={showSnackbar} setLoading={setLoading} />} />
            </>
        )}
        {/* {permissionMap?.["Configuration"]?.["User & Role Management"] && (
          <Route path="/configuration/user-role-management" element={<Permissions showSnackbar={showSnackbar} setLoading={setLoading} />} />    
        )} */}
        {permissionMap?.["Configuration"]?.["User & Role Management"]?.includes("Create Users") && (
                <Route path="/configuration/user-role-management/users" element={<CreateUsers showSnackbar={showSnackbar} setLoading={setLoading} />} />
        )}
        {permissionMap?.["Configuration"]?.["User & Role Management"]?.includes("Assign Client") && (
          <Route path="/configuration/user-role-management/users-client" element={<AssignClient showSnackbar={showSnackbar} setLoading={setLoading} />} />
        )}
        {permissionMap?.["Configuration"]?.["User & Role Management"]?.includes("Create Role") && (
                <Route path="/configuration/user-role-management/role" element={<CreateRole showSnackbar={showSnackbar} setLoading={setLoading} />} />
        )}
        {permissionMap?.["Configuration"]?.["User & Role Management"]?.includes("Assign Permissions")  && (
                <Route path="/configuration/user-role-management/role-permission" element={<AssignPermission showSnackbar={showSnackbar} setLoading={setLoading} />} />
        )}

        {permissionMap?.["Configuration"]?.["Developer Setting"]?.includes("Access Configuration") && (
          <Route path="/configuration/developer-settings/access-configuration" element={<AccessConfiguration showSnackbar={showSnackbar} setLoading={setLoading} />} />
        )}

        <Route path="/configuration/developer-settings/create-report" element={<CreateReport showSnackbar={showSnackbar} setLoading={setLoading} />} />

        {permissionMap?.["Configuration"]?.["Holidays"] && (
          <Route path="/configuration/holidays" element={<Holidays showSnackbar={showSnackbar} setLoading={setLoading} />} />
        )}
        {permissionMap?.["Configuration"]?.["Branch Holidays"] && (
          <Route path="/configuration/branch-holidays" element={<ClientUnitWiseHolidays showSnackbar={showSnackbar} setLoading={setLoading} />} />
        )}

        <Route path="/permission" element={<CreatePermissions />} />
        <Route path="/configuration/form-configuraion" element={<FormConfiguration showSnackbar={showSnackbar} setLoading={setLoading} />} />
        <Route path="/configuration/employee-branch-transfer" element={<EmployeeBranchTransfer showSnackbar={showSnackbar} setLoading={setLoading} />} />
        <Route path="/configuration/Forms" element={<CreateForm showSnackbar={showSnackbar} setLoading={setLoading} />} />
        <Route path="/configuration/act" element={<CreateAct showSnackbar={showSnackbar} setLoading={setLoading} />} />
        <Route path="/configuration/frequency" element={<CreateFrequency showSnackbar={showSnackbar} setLoading={setLoading} />} />
        <Route path="*" element={<NotFound />} />
      </>
    );
  }
// export default Global_routes
